import CompanyAddPage from './add/'

export default {
  CompanyAddPage
}
